import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../ui/alert-dialog';
import { API, auth, err } from '../invoices/invoiceApi';

export const TestSendDialog = ({ open, onOpenChange, token, meta, subject, to }) => {
  const [sending, setSending] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/admin/email-preview/${encodeURIComponent(meta.key)}/test`, { to, confirm: true }, auth(token));
      toast.success(`Test email sent to ${to}`);
      onOpenChange(false);
    } catch (ex) {
      toast.error(err(ex, 'Test email was not sent'));
    } finally {
      setSending(false);
    }
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="email-preview-test-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Send a real test email?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              <p>This sends one real email through your active sender, using sample data.</p>
              <p><span className="text-neutral-500">Email:</span> {meta.label}</p>
              <p><span className="text-neutral-500">Subject:</span> [TEST] {subject}</p>
              <p data-testid="email-preview-test-recipient"><span className="text-neutral-500">To:</span> <strong>{to}</strong></p>
              <p className="text-xs">It is marked as a test and is never sent to a customer address.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="email-preview-test-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={send} disabled={sending} data-testid="email-preview-test-confirm">{sending ? 'Sending…' : 'Send test'}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
